
// Exports the selected database implementation based on a setting (KV by default)
import * as kvDb from './kv'
import * as mongoDb from './mongodb'

const DB_BACKEND = process.env.DB_BACKEND || 'kv' // 'kv' (default) or 'mongodb'

const db = DB_BACKEND === 'mongodb' ? mongoDb : kvDb

export default db
